import { Box, Table, TableBody, TableRow, Typography } from '@mui/material'
import TitleUl from '../Elements/TitleUl'
import { useSelector } from 'react-redux'
import ItemStudent from '../Elements/ItemStudent'
import LoadingSpinner from '../../../../../../Loading/LoadingSpinner'

const ByClasses = ({ isLoading, view = 'current' }) => {
  const field = view === 'current' ? 'byClasses' : 'byClassesHistory'
  const byClasses = useSelector((state) => state?.analytics?.analyticsCurriculum?.[field] || [])
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {byClasses.length === 0 && (
            <Box className='flex justify-center items-center h-40'>
              <Typography variant='h6' color='textSecondary'>
                No data available
              </Typography>
            </Box>
          )}
          {byClasses.map((classItem) => (
            <Box key={classItem.ulId}>
              <Box className='bg-primary text-primary-foreground flex sticky top-10 z-1 px-4 py-2'>
                <TitleUl ul={classItem} results={classItem.results || []} />
              </Box>
              <Table>
                <TableBody>
                  {classItem.students.map((s) => (
                    <TableRow key={s.studentId}>
                      <ItemStudent
                        student={{
                          photo: `${s.studentCode}.jpg`,
                          fullName: s.studentName,
                          code: s.studentCode,
                          studentId: s.studentId
                        }}
                        lcs={s.lcs}
                        result={s.result}
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          ))}
        </>
      )}
    </>
  )
}

export default ByClasses
